module.exports = __webpack_public_path__ + "0d8c84e58cdd3d7ae8ee2b77ed701e01.svg";